const NIPIGE_BASE_URL = "https://dev.app.fastforge.ai";
const CHATBOT_BASE_URL = "https://chatbot.nipige.com";

const NIPIGE_CAP = `${NIPIGE_BASE_URL}/cap`;
const NIPIGE_CATALOG = `${NIPIGE_BASE_URL}/catalog`;
const NIPIGE_INVENTORY = `${NIPIGE_BASE_URL}/store`;
const NIPIGE_ORDER = `${NIPIGE_BASE_URL}/order`;
const NIPIGE_ADVERTISEMENT = `${NIPIGE_BASE_URL}/advertisement`;
const NIPIGE_STORAGE = `${NIPIGE_BASE_URL}/storage`;
const NIPIGE_RBAC = `${NIPIGE_BASE_URL}/rbac`;
const NIPIGE_CHECKOUT = `${NIPIGE_BASE_URL}/checkout`;
const NIPIGE_SUBSCRIBE = `${NIPIGE_BASE_URL}/subscription-payments`;
const NIPIGE_BULKIMPORT = `${NIPIGE_BASE_URL}/bulk-upload`;
const NIPIGE_BUCKET_BASEURL = "https://fastforge-dev.s3.amazonaws.com";
const GOOGLE_MAP_KEY = "AIzaSyB8p-UFwYyJ4tUhksQTmnWFjAovhRY9N3c";
const PAYTM_MID = "sgCBVB10729254640019";
const PAYTM_URL = "https://securegw-stage.paytm.in";

export {
    NIPIGE_BASE_URL,
    CHATBOT_BASE_URL,
    NIPIGE_ADVERTISEMENT,
    NIPIGE_BUCKET_BASEURL,
    NIPIGE_CAP,
    NIPIGE_CATALOG,
    NIPIGE_ORDER,
    NIPIGE_RBAC,
    NIPIGE_CHECKOUT,
    NIPIGE_STORAGE,
    NIPIGE_INVENTORY,
    NIPIGE_BULKIMPORT,
    GOOGLE_MAP_KEY,
    NIPIGE_SUBSCRIBE,
    PAYTM_MID,
    PAYTM_URL,
};
